
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1dhEU", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $8Yr6I = parcelRequire("8Yr6I");

var $etuMO = parcelRequire("etuMO");


var $inPa6 = parcelRequire("inPa6");


var $5mB97 = parcelRequire("5mB97");


var $hxQwS = parcelRequire("hxQwS");


var $duwSm = parcelRequire("duwSm");


var $3jwuS = parcelRequire("3jwuS");


var $yuV6Z = parcelRequire("yuV6Z");


var $bQm3c = parcelRequire("bQm3c");


var $b3j2Y = parcelRequire("b3j2Y");


var $luv00 = parcelRequire("luv00");


var $3shHM = parcelRequire("3shHM");


var $brn6e = parcelRequire("brn6e");


var $9MhzF = parcelRequire("9MhzF");


var $8rneB = parcelRequire("8rneB");


var $crLHf = parcelRequire("crLHf");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");







const $af938bba01231491$var$actions = {
    loadEmojiDescription: (args)=>({ getState: getState, setState: setState })=>{
            /**
     * Helper function to update the emoji in the cache.
     * Maps the emoji's id string to the emoji description, as well as metadata about the promise state.
     */ const { emojiId: emojiId } = args;
            const updateEmojiDescriptionState = (emojiDescriptionState)=>{
                setState({
                    ...getState(),
                    [emojiId]: emojiDescriptionState
                });
            };
            (0, $brn6e.getEmojiFromEmojiId)(args).then((emojiDescription)=>{
                updateEmojiDescriptionState({
                    emojiDescription: emojiDescription
                });
            }).catch((error)=>{
                updateEmojiDescriptionState({
                    error: error
                });
            });
        }
};
const $af938bba01231491$var$EmojiStore = (0, $1P1Tu.createStore)({
    initialState: {},
    actions: $af938bba01231491$var$actions,
    name: 'EmojiStore'
});
/**
 * This sweet-state selector function is an important optimization. The useEmojiDescription hook only will rerender when
 *   1. the emoji prop changes, or
 *   2. the result of this function changes
 * This way, we prevent a single cache update (e.g. the successful fetch of an emojiDescription) from rerendering every emoji.
 */ const $af938bba01231491$var$getEmojiDescription = (state, emoji)=>{
    // In this case, the caller already has an EmojiDescription, so we just return it.
    if (typeof emoji === 'object') return {
        emojiDescription: emoji
    };
    // Try to get the emoji from the cache
    const emojiId = (0, $8rneB.sanitizeEmojiValue)(emoji);
    if (emojiId in state) return state[emojiId];
    return {};
};
const $af938bba01231491$export$adcf538f30a110e0 = (0, $9zUhf.createHook)($af938bba01231491$var$EmojiStore, {
    selector: $af938bba01231491$var$getEmojiDescription
});


const $c7aa17181d3b9fa9$var$EmojiWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        const { isPageTitleComponent: isPageTitleComponent, hasCoverPicture: hasCoverPicture, shouldRemoveEmojiLeftPadding: shouldRemoveEmojiLeftPadding, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1e0c1txw _1bah1h6o _ca0qze3t _n3tdze3t",
            __cmplp.isPageTitleComponent ? __cmplp.hasCoverPicture ? "_p12fys9h" : "_p12f1ylp" : "_p12f1f4h",
            __cmplp.isPageTitleComponent ? __cmplp.hasCoverPicture ? "_u5f3v47k" : "_u5f3u2gc" : "_u5f312x7",
            __cmplp.shouldRemoveEmojiLeftPadding ? "_19bvze3t" : __cmplp.isPageTitleComponent ? __cmplp.hasCoverPicture ? "_19bvv47k" : "_19bvu2gc" : "_19bv12x7",
            __cmplp.isPageTitleComponent ? "_11c81iff" : "_11c810sd",
            __cmplp.isPageTitleComponent ? "_80omtlke" : "_80om1wug",
            __cmplp.isPageTitleComponent ? "_4cvr1h6o" : "_4cvr4jg8",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $c7aa17181d3b9fa9$var$ResourcedEmojiWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1xdi1txw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $c7aa17181d3b9fa9$var$EmbedImage = (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { emoji: emoji, height: height, primaryColor: primaryColor } = t0;
    const intl = (0, $8C5kA.default)();
    const [hasImageError, setHasImageError] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setHasImageError(true);
        };
        $[0] = t1;
    } else t1 = $[0];
    const handleImageError = t1;
    let t2;
    if ($[1] !== emoji || $[2] !== hasImageError || $[3] !== height || $[4] !== intl || $[5] !== primaryColor) {
        t2 = hasImageError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($duwSm))), {
            color: primaryColor,
            label: intl.formatMessage($c7aa17181d3b9fa9$var$i18n.embed),
            spacing: "spacious",
            testId: "embed-svg"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
            src: emoji,
            height: height,
            alt: "",
            onError: handleImageError
        });
        $[1] = emoji;
        $[2] = hasImageError;
        $[3] = height;
        $[4] = intl;
        $[5] = primaryColor;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
};
const $c7aa17181d3b9fa9$export$8d59648ac142d001 = (t0)=>{
    const $ = (0, $frIzR.c)(101);
    const { emoji: emoji, primaryColor: primaryColor, context: context, height: t1, contentType: t2, showTooltip: t3, wrapper: wrapper, loadingMargin: loadingMargin, renderResourcedEmoji: t4, hasCoverPicture: hasCoverPicture, isPageTitleComponent: t5, shouldRemoveEmojiLeftPadding: t6 } = t0;
    const height = t1 === undefined ? 26 : t1;
    const contentType = t2 === undefined ? "page" : t2;
    const showTooltip = t3 === undefined ? false : t3;
    const renderResourcedEmoji = t4 === undefined ? false : t4;
    const isPageTitleComponent = t5 === undefined ? false : t5;
    const shouldRemoveEmojiLeftPadding = t6 === undefined ? false : t6;
    const intl = (0, $8C5kA.default)();
    const { userId: userId, cloudId: cloudId, isLoggedIn: isLoggedIn, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [t7, t8] = (0, $af938bba01231491$export$adcf538f30a110e0)(emoji);
    const { emojiDescription: emojiDescription, error: error } = t7;
    const { loadEmojiDescription: loadEmojiDescription } = t8;
    let t9;
    if ($[0] !== emoji) {
        t9 = typeof emoji === "string" ? (0, $8rneB.sanitizeEmojiValue)(emoji) : emoji && typeof emoji === "object" ? (0, $8rneB.sanitizeEmojiValue)(emoji.id) : null;
        $[0] = emoji;
        $[1] = t9;
    } else t9 = $[1];
    const emojiId = t9;
    const isSSR = !!window.__SSR_RENDERED__ || renderResourcedEmoji;
    const isGuestUser = !isLicensed || !isLoggedIn;
    const t10 = !!cloudId;
    let t11;
    if ($[2] !== isGuestUser || $[3] !== isSSR || $[4] !== t10) {
        t11 = (0, $yuV6Z.getEmojiSSRSupport)({
            isSSR: isSSR,
            hasCloudId: t10,
            isGuestUser: isGuestUser
        });
        $[2] = isGuestUser;
        $[3] = isSSR;
        $[4] = t10;
        $[5] = t11;
    } else t11 = $[5];
    const isEmojiSSRSupported = t11;
    const shouldRenderResourcedEmoji = !!emojiId && !!userId && isEmojiSSRSupported;
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    let t12;
    let t13;
    if ($[6] !== cloudId || $[7] !== emojiId || $[8] !== isPageTitleComponent) {
        t12 = ()=>{
            if (emojiId && isPageTitleComponent) {
                const url = (0, $yuV6Z.getOptimisticImageURL)(cloudId, emojiId);
                if (url) (0, $brn6e.maybeOverrideFaviconWithEmoji)(url);
            }
            return ()=>{
                if (isPageTitleComponent) (0, $brn6e.maybeOverrideFaviconWithEmoji)(null);
            };
        };
        t13 = [
            isPageTitleComponent,
            emojiId,
            cloudId
        ];
        $[6] = cloudId;
        $[7] = emojiId;
        $[8] = isPageTitleComponent;
        $[9] = t12;
        $[10] = t13;
    } else {
        t12 = $[9];
        t13 = $[10];
    }
    (0, $42omo.useEffect)(t12, t13);
    let t14;
    let t15;
    if ($[11] !== cloudId || $[12] !== emojiDescription || $[13] !== emojiId || $[14] !== loadEmojiDescription || $[15] !== shouldRenderResourcedEmoji || $[16] !== userId) {
        t14 = ()=>{
            if (!shouldRenderResourcedEmoji && emojiId && !emojiDescription) loadEmojiDescription({
                emojiId: emojiId,
                userId: userId,
                cloudId: cloudId
            });
        };
        t15 = [
            loadEmojiDescription,
            emojiId,
            emojiDescription,
            cloudId,
            userId,
            shouldRenderResourcedEmoji
        ];
        $[11] = cloudId;
        $[12] = emojiDescription;
        $[13] = emojiId;
        $[14] = loadEmojiDescription;
        $[15] = shouldRenderResourcedEmoji;
        $[16] = userId;
        $[17] = t14;
        $[18] = t15;
    } else {
        t14 = $[17];
        t15 = $[18];
    }
    (0, $42omo.useEffect)(t14, t15);
    const Wrapper = wrapper || $c7aa17181d3b9fa9$var$EmojiWrapper;
    if (typeof emoji === "string") {
        let santiziedEmoji;
        let t16;
        if ($[19] !== emoji) {
            santiziedEmoji = (0, $8rneB.sanitizeEmojiValue)(emoji);
            t16 = (0, $9MhzF.isValidUrl)(santiziedEmoji);
            $[19] = emoji;
            $[20] = santiziedEmoji;
            $[21] = t16;
        } else {
            santiziedEmoji = $[20];
            t16 = $[21];
        }
        if (t16) {
            const t17 = Boolean(hasCoverPicture);
            let t18;
            if ($[22] !== height || $[23] !== primaryColor || $[24] !== santiziedEmoji) {
                t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c7aa17181d3b9fa9$var$EmbedImage, {
                    emoji: santiziedEmoji,
                    height: height,
                    primaryColor: primaryColor
                });
                $[22] = height;
                $[23] = primaryColor;
                $[24] = santiziedEmoji;
                $[25] = t18;
            } else t18 = $[25];
            let t19;
            if ($[26] !== Wrapper || $[27] !== isPageTitleComponent || $[28] !== shouldRemoveEmojiLeftPadding || $[29] !== ssrPlaceholderIdProp || $[30] !== t17 || $[31] !== t18) {
                t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Wrapper, {
                    "data-testid": "emoji-wrapper",
                    hasCoverPicture: t17,
                    isPageTitleComponent: isPageTitleComponent,
                    shouldRemoveEmojiLeftPadding: shouldRemoveEmojiLeftPadding,
                    "data-vc": "emoji-component",
                    ...ssrPlaceholderIdProp
                }, t18);
                $[26] = Wrapper;
                $[27] = isPageTitleComponent;
                $[28] = shouldRemoveEmojiLeftPadding;
                $[29] = ssrPlaceholderIdProp;
                $[30] = t17;
                $[31] = t18;
                $[32] = t19;
            } else t19 = $[32];
            return t19;
        }
    }
    if (contentType === "embed" && !emoji) {
        const t16 = Boolean(hasCoverPicture);
        let t17;
        if ($[33] !== intl) {
            t17 = intl.formatMessage($c7aa17181d3b9fa9$var$i18n.embed);
            $[33] = intl;
            $[34] = t17;
        } else t17 = $[34];
        let t18;
        if ($[35] !== primaryColor || $[36] !== t17) {
            t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($duwSm))), {
                color: primaryColor,
                label: t17,
                testId: "embed-svg"
            });
            $[35] = primaryColor;
            $[36] = t17;
            $[37] = t18;
        } else t18 = $[37];
        let t19;
        if ($[38] !== Wrapper || $[39] !== isPageTitleComponent || $[40] !== shouldRemoveEmojiLeftPadding || $[41] !== ssrPlaceholderIdProp || $[42] !== t16 || $[43] !== t18) {
            t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Wrapper, {
                "data-testid": "emoji-wrapper",
                hasCoverPicture: t16,
                isPageTitleComponent: isPageTitleComponent,
                shouldRemoveEmojiLeftPadding: shouldRemoveEmojiLeftPadding,
                "data-vc": "emoji-component",
                ...ssrPlaceholderIdProp
            }, t18);
            $[38] = Wrapper;
            $[39] = isPageTitleComponent;
            $[40] = shouldRemoveEmojiLeftPadding;
            $[41] = ssrPlaceholderIdProp;
            $[42] = t16;
            $[43] = t18;
            $[44] = t19;
        } else t19 = $[44];
        return t19;
    }
    if (typeof emoji === "string" && (0, $brn6e.emojiExp).test(emoji)) {
        const t16 = !!hasCoverPicture;
        let t17;
        if ($[45] !== Wrapper || $[46] !== emoji || $[47] !== isPageTitleComponent || $[48] !== shouldRemoveEmojiLeftPadding || $[49] !== ssrPlaceholderIdProp || $[50] !== t16) {
            t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Wrapper, {
                "data-testid": "emoji-wrapper",
                hasCoverPicture: t16,
                isPageTitleComponent: isPageTitleComponent,
                shouldRemoveEmojiLeftPadding: shouldRemoveEmojiLeftPadding,
                "data-vc": "emoji-component",
                ...ssrPlaceholderIdProp
            }, emoji);
            $[45] = Wrapper;
            $[46] = emoji;
            $[47] = isPageTitleComponent;
            $[48] = shouldRemoveEmojiLeftPadding;
            $[49] = ssrPlaceholderIdProp;
            $[50] = t16;
            $[51] = t17;
        } else t17 = $[51];
        return t17;
    }
    if (!shouldRenderResourcedEmoji) {
        if (emojiDescription === undefined) {
            let t16;
            if ($[52] !== height || $[53] !== loadingMargin) {
                t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $crLHf.EmojiPlaceholder), {
                    height: height,
                    loadingMargin: loadingMargin
                });
                $[52] = height;
                $[53] = loadingMargin;
                $[54] = t16;
            } else t16 = $[54];
            return t16;
        } else if (emojiDescription === null) {
            if (context !== "smartCard") return null;
            let t16;
            if ($[55] !== contentType || $[56] !== intl) {
                t16 = contentType === "blogpost" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hxQwS.default), {
                    label: intl.formatMessage($c7aa17181d3b9fa9$var$i18n.blogpost),
                    testId: "blog-icon"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5mB97))), {
                    label: intl.formatMessage($c7aa17181d3b9fa9$var$i18n.document),
                    testId: "document-icon"
                });
                $[55] = contentType;
                $[56] = intl;
                $[57] = t16;
            } else t16 = $[57];
            return t16;
        }
    }
    let emojiComponent = null;
    if (shouldRenderResourcedEmoji) {
        let t16;
        if ($[58] !== emojiId) {
            t16 = {
                id: emojiId,
                shortName: emojiId
            };
            $[58] = emojiId;
            $[59] = t16;
        } else t16 = $[59];
        let t17;
        if ($[60] !== cloudId || $[61] !== userId) {
            t17 = (0, $8rneB.getEmojiProvider)(cloudId, userId);
            $[60] = cloudId;
            $[61] = userId;
            $[62] = t17;
        } else t17 = $[62];
        let t18;
        if ($[63] !== cloudId || $[64] !== emojiId) {
            t18 = (0, $yuV6Z.getOptimisticImageURL)(cloudId, emojiId, "XXXHDPI");
            $[63] = cloudId;
            $[64] = emojiId;
            $[65] = t18;
        } else t18 = $[65];
        let t19;
        if ($[66] !== height || $[67] !== loadingMargin) {
            t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $crLHf.EmojiPlaceholder), {
                height: height,
                loadingMargin: loadingMargin
            });
            $[66] = height;
            $[67] = loadingMargin;
            $[68] = t19;
        } else t19 = $[68];
        let t20;
        if ($[69] !== height || $[70] !== showTooltip || $[71] !== t16 || $[72] !== t17 || $[73] !== t18 || $[74] !== t19) {
            t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c7aa17181d3b9fa9$var$ResourcedEmojiWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $etuMO.default), {
                emojiId: t16,
                emojiProvider: t17,
                showTooltip: showTooltip,
                fitToHeight: height,
                optimisticImageURL: t18,
                customFallback: t19,
                pageTitleEmoji: true
            }));
            $[69] = height;
            $[70] = showTooltip;
            $[71] = t16;
            $[72] = t17;
            $[73] = t18;
            $[74] = t19;
            $[75] = t20;
        } else t20 = $[75];
        emojiComponent = t20;
    } else if (emojiDescription) {
        let t16;
        if ($[76] !== cloudId || $[77] !== context || $[78] !== createAnalyticsEvent || $[79] !== emoji || $[80] !== emojiDescription || $[81] !== emojiId || $[82] !== isLivePage || $[83] !== loadEmojiDescription || $[84] !== userId) {
            t16 = ()=>{
                console.error("Failed to load emoji", emoji);
                (0, $3shHM.onFailedToLoadEmoji)({
                    createAnalyticsEvent: createAnalyticsEvent,
                    emoji: emojiDescription,
                    context: context,
                    isLivePage: isLivePage
                });
                if (emojiId && userId) loadEmojiDescription({
                    emojiId: emojiId,
                    userId: userId,
                    cloudId: cloudId
                });
            };
            $[76] = cloudId;
            $[77] = context;
            $[78] = createAnalyticsEvent;
            $[79] = emoji;
            $[80] = emojiDescription;
            $[81] = emojiId;
            $[82] = isLivePage;
            $[83] = loadEmojiDescription;
            $[84] = userId;
            $[85] = t16;
        } else t16 = $[85];
        let t17;
        if ($[86] !== emojiDescription || $[87] !== height || $[88] !== showTooltip || $[89] !== t16) {
            t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Yr6I.default), {
                emoji: emojiDescription,
                fitToHeight: height,
                showTooltip: showTooltip,
                onLoadError: t16
            });
            $[86] = emojiDescription;
            $[87] = height;
            $[88] = showTooltip;
            $[89] = t16;
            $[90] = t17;
        } else t17 = $[90];
        emojiComponent = t17;
    }
    const t16 = !!hasCoverPicture;
    let t17;
    if ($[91] !== error) {
        t17 = error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        $[91] = error;
        $[92] = t17;
    } else t17 = $[92];
    let t18;
    if ($[93] !== Wrapper || $[94] !== emojiComponent || $[95] !== isPageTitleComponent || $[96] !== shouldRemoveEmojiLeftPadding || $[97] !== ssrPlaceholderIdProp || $[98] !== t16 || $[99] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Wrapper, {
            "data-testid": "emoji-wrapper",
            hasCoverPicture: t16,
            isPageTitleComponent: isPageTitleComponent,
            shouldRemoveEmojiLeftPadding: shouldRemoveEmojiLeftPadding,
            "data-vc": "emoji-component",
            ...ssrPlaceholderIdProp
        }, emojiComponent, t17);
        $[93] = Wrapper;
        $[94] = emojiComponent;
        $[95] = isPageTitleComponent;
        $[96] = shouldRemoveEmojiLeftPadding;
        $[97] = ssrPlaceholderIdProp;
        $[98] = t16;
        $[99] = t17;
        $[100] = t18;
    } else t18 = $[100];
    return t18;
};
$c7aa17181d3b9fa9$export$8d59648ac142d001.displayName = 'EmojiComponent';
const $c7aa17181d3b9fa9$var$i18n = (0, $cgtv4.defineMessages)({
    blogpost: {
        id: "emoji-title.icon.blogpost",
        defaultMessage: "Blog"
    },
    embed: {
        id: "emoji-title.icon.embed",
        defaultMessage: "Embed"
    },
    document: {
        id: "emoji-title.icon.document",
        defaultMessage: "Document"
    }
});
module.exports["EmojiComponent"] = $c7aa17181d3b9fa9$export$8d59648ac142d001;

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $frIzR.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("9MhzF", function(module, exports) {
const $df5c51c7bf673d12$export$bef94a5618bf18bf = (string)=>{
    try {
        return Boolean(new URL(string));
    } catch (e) {
        return false;
    }
};
module.exports["isValidUrl"] = $df5c51c7bf673d12$export$bef94a5618bf18bf;

});

parcelRegister("8rneB", function(module, exports) {

var $ibzAc = parcelRequire("ibzAc");


var $32x2E = parcelRequire("32x2E");


var $5amrO = parcelRequire("5amrO");

const $61659933fe71a4ee$export$d2d37cdca5b73056 = (data, emojiFieldName)=>data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.version?.number || 0;
const $61659933fe71a4ee$export$4f65bc4b6ab2638 = (data, emojiFieldName)=>(data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$7f77dde40cb9b60a = (emojiValue)=>(emojiValue || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$var$transformProperty = (property)=>{
    if (property) return {
        propertyId: property?.id ?? '',
        value: (property?.value || '').replace(/['"]+/g, '').replace(/null/, ''),
        versionNumber: 'version' in property && property.version?.number || 0
    };
};
const $61659933fe71a4ee$var$findPropertyByKey = (object, key)=>$61659933fe71a4ee$var$transformProperty(object?.properties?.nodes?.find((node)=>node?.key === key));
const $61659933fe71a4ee$export$1b37039eb4b94aa5 = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-published');
const $61659933fe71a4ee$export$4d2921b7085d93bb = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-draft');
const $61659933fe71a4ee$export$f6641c501f8a1aee = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$e1cb12562674727b = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$db0acf1152e62ad6 = (data)=>((data?.content?.nodes?.[0] || data?.singleContent)?.emojiTitlePublished?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$a5b3ff94c918547 = (content)=>(content?.emoji?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$c4fe69c947489b89 = (content)=>(content?.emojiDraft?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$bb520a2176fa2873 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$fbf43d9e87015d93 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$b8852397200defa1 = (data, emojiFieldName)=>{
    let nodes;
    if (data && 'content' in data) nodes = data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0];
    else nodes = data?.emojiTitlePublished?.nodes?.[0];
    return !!nodes?.value && nodes?.value !== '""' && nodes?.value !== '"null"';
};
const $61659933fe71a4ee$export$496af73e8e85fd08 = (data)=>{
    return $61659933fe71a4ee$export$b8852397200defa1(data, 'emojiTitlePublished');
};
const $61659933fe71a4ee$export$53519180ca077ff2 = (data)=>$61659933fe71a4ee$export$b8852397200defa1(data, (0, $5amrO.EMOJI_TITLE_PUBLISHED_FIELD));
const $61659933fe71a4ee$export$8210f5f78c0bcf27 = async (cloudId, userId)=>{
    return await (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
        cloudId: cloudId,
        userId: userId
    });
};
var $61659933fe71a4ee$export$66d7571a7d7aad65 = /*#__PURE__*/ function(DefaultTitleEmojiValues) {
    DefaultTitleEmojiValues["LIVE_PAGE_DEFAULT"] = "live-page-default";
    DefaultTitleEmojiValues["NONE"] = "none";
    return DefaultTitleEmojiValues;
}({});
const $61659933fe71a4ee$export$efb819bf9c3235c7 = (data)=>{
    if (!data) return false;
    const defaultTitleEmoji = data?.content?.nodes?.[0]?.contentProperties?.latest?.defaultTitleEmoji;
    // This property denotes whether or not we show a default emoji icon, and is initially set to null to avoid backfilling on the BE;
    // therefore, a null value OR a specifically set value implies that we need to show a default icon, while a "none" value implies
    // that we should not show an icon. The default icon should also be overriden by a user-set emoji.
    return defaultTitleEmoji === null || defaultTitleEmoji === "live-page-default";
};
module.exports["getVersionNumber"] = $61659933fe71a4ee$export$d2d37cdca5b73056;
module.exports["getEmojiId"] = $61659933fe71a4ee$export$4f65bc4b6ab2638;
module.exports["sanitizeEmojiValue"] = $61659933fe71a4ee$export$7f77dde40cb9b60a;
module.exports["getEmojiPublishedProperty"] = $61659933fe71a4ee$export$1b37039eb4b94aa5;
module.exports["getEmojiDraftProperty"] = $61659933fe71a4ee$export$4d2921b7085d93bb;
module.exports["getEmojiFromPublishedPageProperties"] = $61659933fe71a4ee$export$f6641c501f8a1aee;
module.exports["getEmojiFromDraftPageProperties"] = $61659933fe71a4ee$export$e1cb12562674727b;
module.exports["getPublishedEmojiId"] = $61659933fe71a4ee$export$db0acf1152e62ad6;
module.exports["getEmojiValueFromContent"] = $61659933fe71a4ee$export$a5b3ff94c918547;
module.exports["getEmojiDraftFromProperties"] = $61659933fe71a4ee$export$bb520a2176fa2873;
module.exports["getEmojiPublishedFromProperties"] = $61659933fe71a4ee$export$fbf43d9e87015d93;
module.exports["getHasEmoji"] = $61659933fe71a4ee$export$b8852397200defa1;
module.exports["doesContentHaveEmojiPublished"] = $61659933fe71a4ee$export$496af73e8e85fd08;
module.exports["getEmojiProvider"] = $61659933fe71a4ee$export$8210f5f78c0bcf27;
module.exports["getHasLiveDocsDefaultEmoji"] = $61659933fe71a4ee$export$efb819bf9c3235c7;

});

parcelRegister("32x2E", function(module, exports) {

var $5d9b4 = parcelRequire("5d9b4");


var $5B7Fh = parcelRequire("5B7Fh");


var $7W8i8 = parcelRequire("7W8i8");

const $dc26b22176754e2e$var$logger = (0, $7W8i8.getLogger)('emoji-provider');
const $dc26b22176754e2e$export$ca6dda5263526f75 = '/gateway/api/emoji';
const $dc26b22176754e2e$export$240be4f98742fdda = (cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const config = {
        providers: [
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/standard`
            },
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/atlassian`
            }
        ],
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks || {}
    };
    if (cloudId && (userId || allowAnonymousAccess)) config.providers.push({
        url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/site`
    });
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $dc26b22176754e2e$export$1504d130127dbc5f = (_EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? false;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    return `${cloudId}_${userId}_${allowAnonymousAccess}_${emojiSSRConfig ? 'withSSR' : 'noSSR'}`;
};
const $dc26b22176754e2e$export$9e6d4bd03aadcea5 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? undefined;
    const emojiConfig = $dc26b22176754e2e$export$240be4f98742fdda(cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess);
    return new EmojiResource(emojiConfig);
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return emojiResource.getEmojiProvider();
    } catch (err) {
        return Promise.resolve(undefined);
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$b263a0680b18512c = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return new (0, $5B7Fh.EmojiNodeDataProvider)(emojiResource);
    } catch (err) {
        return undefined;
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
module.exports["getEmojiConfig"] = $dc26b22176754e2e$export$240be4f98742fdda;
module.exports["getEmojiProvider"] = $dc26b22176754e2e$export$8210f5f78c0bcf27;
module.exports["getEmojiNodeDataProvider"] = $dc26b22176754e2e$export$b263a0680b18512c;

});

parcelRegister("5B7Fh", function(module, exports) {

var $eTj7Y = parcelRequire("eTj7Y");


var $fhsiz = parcelRequire("fhsiz");


var $i0VEL = parcelRequire("i0VEL");

class $57ed069fa0b7e304$export$67106c51beb59865 extends (0, $i0VEL.NodeDataProvider) {
    isNodeSupported(node) {
        return node.type === 'emoji';
    }
    nodeDataKey(node) {
        return node.attrs.id || node.attrs.shortName;
    }
    /**
   * Implementing different re-fetching strategy for emoji.
   *
   * Default strategy for NodeDataProvider is to:
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   * 4. Re-render node with fresh data.
   *
   * This is similar, but doesn't update the node.
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   */ getData(node, callback) {
        const cached = this.getNodeDataFromCache(node);
        if (cached?.data) {
            callback(cached);
            if (!(0, $eTj7Y.isSSR)() && typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(()=>void this.getDataAsync(node, ()=>{}));
        } else this.getDataAsync(node, callback);
    }
    async fetchNodesData(nodes) {
        // If we have an `optimisticImageApi`, use it to generate a URL immediately.
        // This is how emojis are server-side rendered in Confluence.
        // Without this, the emoji server response will hit timeout on SSR and the emoji will not be rendered.
        //
        // We are using this optimization only in SSR because on client side we need to know a valid emoji size
        // which is not possible to get from optimisticImageApi.
        //
        // Check platform/packages/editor/renderer/src/react/nodes/emoji.tsx
        // and platform/packages/elements/emoji/src/components/common/ResourcedEmojiComponent.tsx
        const getOptimisticImageUrl = this.emojiResource.emojiProviderConfig.optimisticImageApi?.getUrl;
        if ((0, $eTj7Y.isSSR)() && getOptimisticImageUrl) return nodes.map((node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            const optimisticImageURL = getOptimisticImageUrl(emojiId);
            return {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text,
                representation: {
                    height: (0, $fhsiz.defaultEmojiHeight),
                    width: (0, $fhsiz.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true,
                // Type and category are unknown at this point.
                // It's not a big deal, because EmojiNodeView doesn't use them.
                type: '',
                category: ''
            };
        });
        // This is slower path because during access to emojiProvider emojiResource
        // makes a request to fetch all emojis.
        const emojiProvider = await this.emojiProvider;
        const fetches = nodes.map(async (node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            // This usually fast because the emojiProvider already has all emojis fetched.
            const result = await emojiProvider.fetchByEmojiId(emojiId, true);
            // If we have optimisticImageApi, we need to path response and set URL from it to match the URL used in SSR.
            if (getOptimisticImageUrl && result) {
                const optimisticImageURL = getOptimisticImageUrl(emojiId);
                if (result.representation && 'imagePath' in result.representation) return {
                    ...result,
                    representation: {
                        ...result.representation,
                        imagePath: optimisticImageURL
                    }
                };
            }
            return result;
        });
        return Promise.all(fetches);
    }
    constructor(resource){
        super();
        this.name = 'emojiNodeDataProvider';
        this.emojiResource = void 0;
        this.emojiProvider = void 0;
        this.emojiResource = resource;
        this.emojiProvider = resource.getEmojiProvider();
    }
}
module.exports["EmojiNodeDataProvider"] = $57ed069fa0b7e304$export$67106c51beb59865;

});

parcelRegister("5amrO", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $99t4P = parcelRequire("99t4P");

const $bb7cbab4663812b3$export$342dc808a4f4a7ab = 'emoji-title-draft';
const $bb7cbab4663812b3$export$97ffb0b9059d248e = 'emoji-title-published';
const $bb7cbab4663812b3$export$5a027b13986198b7 = 'emojiTitleDraft';
const $bb7cbab4663812b3$export$b78a8db8f4546258 = 'emojiTitlePublished';
const $bb7cbab4663812b3$export$61509c1d76ea5fb2 = (contentType)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isWhiteboardEmoji = (0, $99t4P.isEmojiTitleEnabled)(contentType);
    if (isWhiteboardEmoji || isLivePage) return $bb7cbab4663812b3$export$b78a8db8f4546258;
    else return $bb7cbab4663812b3$export$5a027b13986198b7;
};
const $bb7cbab4663812b3$export$28c62f1b367f9166 = (fieldName)=>{
    return fieldName === $bb7cbab4663812b3$export$b78a8db8f4546258 ? $bb7cbab4663812b3$export$97ffb0b9059d248e : $bb7cbab4663812b3$export$342dc808a4f4a7ab;
};
module.exports["EMOJI_TITLE_DRAFT_FIELD"] = $bb7cbab4663812b3$export$5a027b13986198b7;
module.exports["EMOJI_TITLE_PUBLISHED_FIELD"] = $bb7cbab4663812b3$export$b78a8db8f4546258;
module.exports["useEmojiStatusFieldName"] = $bb7cbab4663812b3$export$61509c1d76ea5fb2;
module.exports["convertEmojiFieldNameToPropertyKey"] = $bb7cbab4663812b3$export$28c62f1b367f9166;

});

parcelRegister("99t4P", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $6b4026d31beb25d0$export$f0410e068eb2ef9e = (contentType)=>{
    return contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles');
};
module.exports["isEmojiTitleEnabled"] = $6b4026d31beb25d0$export$f0410e068eb2ef9e;

});

parcelRegister("crLHf", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fT2ta = parcelRequire("fT2ta");

const $e2c8b616e1533245$var$skeletonWrapperStyles = null;
const $e2c8b616e1533245$var$emojiSkeletonStyles = null;
const $e2c8b616e1533245$export$9fc60f86d5a6479f = (props)=>{
    const $ = (0, $frIzR.c)(3);
    const PLACEHOLDER_SIZE = props.height || 26;
    let t0;
    if ($[0] !== PLACEHOLDER_SIZE || $[1] !== props.loadingMargin) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
            entranceDirection: "left"
        }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o _1bumglyw _sedtglyw"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                style: {
                    width: `${PLACEHOLDER_SIZE}px`,
                    height: `${PLACEHOLDER_SIZE}px`,
                    margin: props.loadingMargin
                },
                className: (0, $gMc0m.default)([
                    "_11q7izff _2rkofajl _18s8ze3t _1e0c1o8l _ca0qze3t"
                ])
            })));
        $[0] = PLACEHOLDER_SIZE;
        $[1] = props.loadingMargin;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
module.exports["EmojiPlaceholder"] = $e2c8b616e1533245$export$9fc60f86d5a6479f;

});

parcelRegister("fEmGS", function(module, exports) {

var $86okN = parcelRequire("86okN");

function $f0827a369f0dafa9$export$f97bd2548c77448c(params) {
    return $f0827a369f0dafa9$var$writeQueryInteropApollo(params);
}
function $f0827a369f0dafa9$var$writeQueryInteropRelay(params) {
    const relayEnv = window.GLOBAL_RELAY_ENV;
    const { query: query, data: data, variables: variables } = params;
    if (!data) return;
    relayEnv.commitUpdate((storeProxy)=>{
        const root = storeProxy.getRoot();
        if (!root) return;
        const queryNode = query;
        const queryFields = queryNode?.operation?.selections;
        if (queryFields) $f0827a369f0dafa9$var$writeQueryFields(storeProxy, root, queryFields, data, variables || {});
    });
}
function $f0827a369f0dafa9$var$writeQueryFields(storeProxy, record, fields, data, variables) {
    if (!record || !data) return;
    for (const field of fields){
        if (field.kind === 'LinkedField') {
            const linkedField = field;
            const fieldData = data[linkedField.name];
            if (fieldData !== undefined) {
                if (Array.isArray(fieldData)) {
                    const linkedRecords = fieldData.map((item)=>{
                        if (item && typeof item === 'object') {
                            const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                            const existingRecord = record.getLinkedRecord(fieldKey);
                            if (existingRecord && linkedField.selections) {
                                $f0827a369f0dafa9$var$writeQueryFields(storeProxy, existingRecord, linkedField.selections, item, variables);
                                return existingRecord;
                            }
                        }
                        return null;
                    }).filter((rec)=>rec !== null);
                    if (linkedRecords.length > 0) {
                        const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                        record.setLinkedRecords(linkedRecords, fieldKey);
                    }
                } else if (fieldData && typeof fieldData === 'object') {
                    const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                    const linkedRecord = record.getLinkedRecord(fieldKey);
                    // If no linked record exists but we have data with an ID, we can try to get the existing record,
                    // or create a new record based on __typename. However, this shouldn't be a common use-case across the codebase,
                    // so we'll skip these code paths for now
                    if (linkedRecord && linkedField.selections) $f0827a369f0dafa9$var$writeQueryFields(storeProxy, linkedRecord, linkedField.selections, fieldData, variables);
                }
            }
        } else if (field.kind === 'ScalarField') {
            const scalarField = field;
            if (data[scalarField.name] !== undefined) record.setValue(data[scalarField.name], scalarField.name);
        }
    }
}
function $f0827a369f0dafa9$var$getFieldKey(field, variables) {
    if (!field.args || field.args.length === 0) return field.name;
    // Compute storage key for fields with arguments
    const args = field.args.map((arg)=>{
        let value;
        if (arg.kind === 'Literal') value = JSON.stringify(arg.value);
        else if (arg.kind === 'Variable') value = JSON.stringify(variables[arg.variableName]);
        else // Fallback for other argument types
        value = JSON.stringify(arg.value);
        return `${arg.name}:${value}`;
    }).join(',');
    return `${field.name}(${args})`;
}
function $f0827a369f0dafa9$var$writeQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].writeQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["writeQueryInterop"] = $f0827a369f0dafa9$export$f97bd2548c77448c;

});

parcelRegister("l1uFv", function(module, exports) {

var $86okN = parcelRequire("86okN");

function $65c7b8940c778902$export$627cb922211284f(params) {
    return $65c7b8940c778902$var$readQueryInteropApollo(params);
}
function $65c7b8940c778902$var$readQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].readQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["readQueryInterop"] = $65c7b8940c778902$export$627cb922211284f;

});

parcelRegister("di8q4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $crLHf = parcelRequire("crLHf");


const $7f6506f09fa8c3c7$export$836160481278e63f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CUFGb",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("gAJqh"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $crLHf.EmojiPlaceholder), props) : null
});
module.exports["LazyEmojiComponentLoader"] = $7f6506f09fa8c3c7$export$836160481278e63f;

});

parcelRegister("gAJqh", function(module, exports) {

let $c1433e2939fce3dd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c1433e2939fce3dd$var$load("l5llo"),
    $c1433e2939fce3dd$var$load("9Oy8P"),
    $c1433e2939fce3dd$var$load("ajMch"),
    $c1433e2939fce3dd$var$load("6wr18"),
    $c1433e2939fce3dd$var$load("kjZZD"),
    $c1433e2939fce3dd$var$load("ffEVr"),
    $c1433e2939fce3dd$var$load("9V45O"),
    $c1433e2939fce3dd$var$load("4izLy"),
    $c1433e2939fce3dd$var$load("6KGrg")
]).then(()=>parcelRequire('1dhEU'));

});

parcelRegister("i7jPX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6421b29072e9fbe0$export$2e2bcd8739ae039);
/* tile.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $6421b29072e9fbe0$var$styles = {
    root: "_2rkol0p1 _1reo15vq _18m915vq _kqswh2mm _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1o9zidpf _16jlidpf _1ul9idpf _1tkeidpf",
    border: "_189ee4h9 _1dqonqa1 _1h6d1l7x",
    inset: "_1iia1wug _bna71wug _1xjx1wug _17521wug",
    nonInset: "_1qwg1osq _mezj1osq _e2oo1osq _w8l51osq _1iia1osq _bna71osq _1xjx1osq _17521osq"
};
const $6421b29072e9fbe0$var$sizeMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz _1wyb19bv",
    xsmall: "_1bsbgktf _4t3igktf _1wyb1crf",
    small: "_1bsb1tcg _4t3i1tcg _1wybdlk8",
    medium: "_1bsbzwfg _4t3izwfg _1wyb7vkz",
    large: "_1bsb1ylp _4t3i1ylp _1wybgktf",
    xlarge: "_1bsbckbl _4t3ickbl _1wyb1tcg"
};
const $6421b29072e9fbe0$var$insetSizeMap = {
    xxsmall: "_1qwg19bv _mezj19bv _e2oo19bv _w8l519bv _5ile19el _1hdc19el _1pc719el _pkax19el",
    xsmall: "_1qwg1crf _mezj1crf _e2oo1crf _w8l51crf _5ilemccc _1hdcmccc _1pc7mccc _pkaxmccc",
    small: "_1qwgdlk8 _mezjdlk8 _e2oodlk8 _w8l5dlk8 _5ilewk7l _1hdcwk7l _1pc7wk7l _pkaxwk7l",
    medium: "_1qwg7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _5ile1gpt _1hdc1gpt _1pc71gpt _pkax1gpt",
    large: "_1qwggktf _mezjgktf _e2oogktf _w8l5gktf _5ile1txs _1hdc1txs _1pc71txs _pkax1txs",
    xlarge: "_1qwg1tcg _mezj1tcg _e2oo1tcg _w8l51tcg _5ilea982 _1hdca982 _1pc7a982 _pkaxa982"
};
const $6421b29072e9fbe0$var$backgroundColorMap = {
    white: "_bfhku67f",
    black: "_bfhkr3uz",
    transparent: "_bfhk1j28",
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.information': "_bfhk19ip",
    'color.background.information.bold': "_bfhkx4w0"
}; /**
    * __Tile__
    *
    * A tile is a rounded square that takes an asset and represents a noun.
    *
    */ 
function $6421b29072e9fbe0$export$2e2bcd8739ae039(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $gMc0m.default)([
            $6421b29072e9fbe0$var$styles.root,
            $6421b29072e9fbe0$var$sizeMap[size],
            isInset ? $6421b29072e9fbe0$var$styles.inset : $6421b29072e9fbe0$var$styles.nonInset,
            isInset && $6421b29072e9fbe0$var$insetSizeMap[size],
            $6421b29072e9fbe0$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $6421b29072e9fbe0$var$styles.border
        ]),
        children: children
    });
}

});

parcelRegister("bCECL", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $e0ycV = parcelRequire("e0ycV");


var $jRsqV = parcelRequire("jRsqV");


var $8jHAi = parcelRequire("8jHAi");


var $9RVmI = parcelRequire("9RVmI");


var $ZDq1z = parcelRequire("ZDq1z");


var $6B0jU = parcelRequire("6B0jU");


var $5tmwS = parcelRequire("5tmwS");


var $cHaKZ = parcelRequire("cHaKZ");


var $di8q4 = parcelRequire("di8q4");


var $2JGYp = parcelRequire("2JGYp");


var $gTyTP = parcelRequire("gTyTP");

const $b2e0c504f331f5cc$export$a1ea799cb5c1b499 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { type: type, emoji: emoji, color: color, subType: subType, height: t1 } = t0;
    const height = t1 === undefined ? 16 : t1;
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const isLivePage = type === "page" && subType === "live" || type === "liveDoc";
    const defaultedType = type === "liveDoc" ? "page" : type;
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) {
        const t2 = emoji || "";
        let t3;
        if ($[0] !== defaultedType || $[1] !== height || $[2] !== t2) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                emoji: t2,
                contentType: defaultedType,
                context: "contentMenu",
                height: height,
                wrapper: $b2e0c504f331f5cc$var$_temp
            });
            $[0] = defaultedType;
            $[1] = height;
            $[2] = t2;
            $[3] = t3;
        } else t3 = $[3];
        return t3;
    }
    const definition = isLivePage && isLivePagesFeatureEnabled ? $b2e0c504f331f5cc$var$iconDefinitions.liveDoc : $b2e0c504f331f5cc$var$iconDefinitions[defaultedType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    let t2;
    if ($[4] !== Icon || $[5] !== color || $[6] !== label.id) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: "",
            color: color,
            testId: label.id
        });
        $[4] = Icon;
        $[5] = color;
        $[6] = label.id;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ({ type: type, emoji: emoji, color: color, subType: subType, height: height = 16 })=>{
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const isLivePage = type === 'page' && subType === 'live' || type === 'liveDoc';
    const defaultedType = type === 'liveDoc' ? 'page' : type; // Prevent using 'liveDoc' type directly
    // embed favicon/default content type icon will also be handled by the emoji component
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emoji || '',
        contentType: defaultedType,
        context: "contentMenu",
        height: height,
        wrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
            }, children)
    });
    const definition = isLivePage && isLivePagesFeatureEnabled ? $b2e0c504f331f5cc$var$iconDefinitions['liveDoc'] : $b2e0c504f331f5cc$var$iconDefinitions[defaultedType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: "",
        color: color,
        testId: label.id
    });
};
const $b2e0c504f331f5cc$var$emojiWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '16px',
    width: '16px',
    height: '16px',
    font: 'font.body.large',
    overflow: 'hidden'
});
const $b2e0c504f331f5cc$var$i18n = (0, $cgtv4.defineMessages)({
    liveDoc: {
        id: "icons.content-icon.label.live-doc",
        defaultMessage: "Live Doc"
    },
    page: {
        id: "icons.content-icon.label.page",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "icons.content-icon.label.blogpost",
        defaultMessage: "Blog"
    },
    whiteboard: {
        id: "icons.content-icon.label.whiteboard",
        defaultMessage: "Whiteboard"
    },
    database: {
        id: "icons.content-icon.label.database",
        defaultMessage: "Database"
    },
    folder: {
        id: "icons.content-icon.label.folder",
        defaultMessage: "Folder"
    },
    space: {
        id: "icons.content-icon.label.space",
        defaultMessage: "Space"
    },
    note: {
        id: "icons.content-icon.label.note",
        defaultMessage: "Note"
    }
});
const $b2e0c504f331f5cc$var$iconDefinitions = {
    liveDoc: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        label: $b2e0c504f331f5cc$var$i18n.liveDoc
    },
    page: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        label: $b2e0c504f331f5cc$var$i18n.page
    },
    blogpost: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        label: $b2e0c504f331f5cc$var$i18n.blogpost
    },
    whiteboard: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        label: $b2e0c504f331f5cc$var$i18n.whiteboard
    },
    database: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        label: $b2e0c504f331f5cc$var$i18n.database
    },
    folder: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))),
        label: $b2e0c504f331f5cc$var$i18n.folder
    },
    space: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cHaKZ))),
        label: $b2e0c504f331f5cc$var$i18n.space
    },
    note: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jRsqV))),
        label: $b2e0c504f331f5cc$var$i18n.note
    }
};
function $b2e0c504f331f5cc$var$_temp(t0) {
    const { children: children } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
    }, children);
}
module.exports["ContentIcon"] = $b2e0c504f331f5cc$export$a1ea799cb5c1b499;

});

parcelRegister("jRsqV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b5a64a2ca9b8ddc91e264b2e4d54e26>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e75905caaf7b6b39$var$_react = $e75905caaf7b6b39$var$_interopRequireDefault((parcelRequire("42omo")));

var $e75905caaf7b6b39$var$_baseNew = $e75905caaf7b6b39$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e75905caaf7b6b39$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notepad".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Whiteboard component 'card'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e75905caaf7b6b39$var$NotepadIcon = (props)=>/*#__PURE__*/ $e75905caaf7b6b39$var$_react.default.createElement($e75905caaf7b6b39$var$_baseNew.default, Object.assign({
        name: "NotepadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1V0h1.5v1h1.75V0h1.5v1h1.75V0H12v1h1a2 2 0 0 1 2 2v7.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6v-3.75a.75.75 0 0 1 .75-.75h3.75V3a.5.5 0 0 0-.5-.5h-1v2h-1.5v-2H8.75v2h-1.5v-2H5.5v2H4zm8.94 9H10.5v2.44zM12 8H4V6.5h8zm-5 2v1.5H4V10z" clip-rule="evenodd"/>`
    }, props));
$e75905caaf7b6b39$var$NotepadIcon.displayName = 'NotepadIcon';
var $e75905caaf7b6b39$var$_default = module.exports.default = $e75905caaf7b6b39$var$NotepadIcon;

});

parcelRegister("2JGYp", function(module, exports) {

var $9MhzF = parcelRequire("9MhzF");


var $5dh5C = parcelRequire("5dh5C");


var $8rneB = parcelRequire("8rneB");

const $3f74e24d74be50af$export$2629e776cd65f583 = (emoji, type)=>{
    /**
   * Why do emojis need to be 'sanitized'? Originally emoji content properties
   * (emoji-title-published, emoji-title-draft) were a part of a REST API
   * where the value would be JSON and not just a string.  This is why emoji
   * values come through with extra quotes and we have to clean that up.
   * A URL with quotes is not a valid URL.
   * e.g. '"https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"' vs.
   * "https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"
   */ const sanitizedEmoji = (0, $8rneB.sanitizeEmojiValue)(emoji);
    const isEmbed = type === 'embed';
    const isEmbedWithoutEmoji = isEmbed && !sanitizedEmoji;
    return sanitizedEmoji && (0, $5dh5C.isValidEmoji)(sanitizedEmoji) || sanitizedEmoji && isEmbed && (0, $9MhzF.isValidUrl)(sanitizedEmoji) || isEmbedWithoutEmoji;
};
module.exports["isValidEmojiOrFavicon"] = $3f74e24d74be50af$export$2629e776cd65f583;

});

parcelRegister("5dh5C", function(module, exports) {
const $e57f5fd4620d2578$export$122aed4aa2d0ca26 = (emoji)=>{
    const invalidEmojiRegex = /([a-z\d_-]+):/;
    return !invalidEmojiRegex.test(emoji);
};
module.exports["isValidEmoji"] = $e57f5fd4620d2578$export$122aed4aa2d0ca26;

});


//# sourceMappingURL=EmojiComponent.380249f3.js.map
